import request from '@/utils/request'
import { resolveApiBase } from '@/utils/apiBase'

export function listQuotePaymentPlans(quoteId) {
  return request({
    url: `/api/quote/${quoteId}/payment-plans`,
    method: 'get'
  })
}

export function getQuotePage(params) {
  return request({
    url: '/api/quote/page',
    method: 'get',
    params
  })
}

export function getQuoteDetail(id) {
  return request({
    url: `/api/quote/${id}`,
    method: 'get'
  })
}

export function saveQuote(data) {
  return request({
    url: '/api/quote',
    method: 'post',
    data
  })
}

export function updateQuote(id, data) {
  return request({
    url: `/api/quote/${id}`,
    method: 'put',
    data
  })
}

export function deleteQuote(id) {
  return request({
    url: `/api/quote/${id}`,
    method: 'delete'
  })
}

export function submitQuote(id) {
  return request({
    url: `/api/quote/${id}/submit`,
    method: 'post'
  })
}

export function approveInternal(id, comment) {
  return request({
    url: `/api/quote/${id}/approve-internal`,
    method: 'post',
    data: { comment }
  })
}

export function rejectInternal(id, comment) {
  return request({
    url: `/api/quote/${id}/reject-internal`,
    method: 'post',
    data: { comment }
  })
}

export function sendQuoteLink(id, displayMode) {
  return request({
    url: `/api/quote/${id}/send-link`,
    method: 'post',
    data: { displayMode }
  })
}

export function listQuoteAttachments(id) {
  return request({
    url: `/api/quote/${id}/attachments`,
    method: 'get'
  })
}

export function uploadQuoteAttachment(id, file) {
  const fd = new FormData()
  fd.append('file', file)
  return request({
    url: `/api/quote/${id}/attachment/upload`,
    method: 'post',
    data: fd,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function downloadQuoteAttachmentUrl(attachmentId) {
  return `${resolveApiBase()}/api/quote/attachment/${attachmentId}/download`
}

export function previewQuoteAttachmentUrl(attachmentId) {
  return `${resolveApiBase()}/api/quote/attachment/${attachmentId}/preview`
}
